import {createContext, useEffect, useState} from "react";
import axios from "axios";
import userService from "../services/user-service";
import {toast} from "react-toastify";
import {menuResource} from "../providers/menu";

export const ProjectContext = createContext(null);

export const ProjectProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [initialPath, setInitialPath] = useState(null);

    useEffect(() => {
        const user = localStorage.getItem("user");
        if (!user) return;
        const userParse = JSON.parse(user);

        axios.defaults.headers.common['Authorization'] = `Bearer ${userParse?.token}`;
        setUser(userParse)

        setInitialPath(getFirstPath(userParse.permissions))
    }, []);

    const getFirstPath = (permissions) => {
        const pathInMenu = menuResource.find(menu => menu.permissions.some(perm => permissions.includes(perm)));
        const pathInSubmenu = pathInMenu?.submenu?.find(sub => sub.permissions.some(perm => permissions.includes(perm)));

        return pathInSubmenu?.link || pathInMenu?.link || "/my-user";
    }

    const login = async (user) => {
        window.localStorage.setItem("user", JSON.stringify(user));
        axios.defaults.headers.common['Authorization'] = `Bearer ${user?.token}`;
        setUser(user);
    }

    const logout = (callback) => {
        userService.logout()
            .then(() => {
                window.localStorage.removeItem("user");
                setUser(null);
                callback();
            })
            .catch(() => toast.error("Não foi possível prosseguir"))
    }

    return (
        <ProjectContext.Provider value={{user, login, logout, initialPath, getFirstPath}}>
            {children}
        </ProjectContext.Provider>
    );
}

